import { CancellationReasonEnum, InspectionResult, InspectionStatus, InspectionType } from 'api';

export const CANCELLATION_REASONS: {
  value: CancellationReasonEnum;
  label: string;
}[] = [
  { label: 'Deal Cancelled', value: 'DC' },
  { label: 'Missed Loading', value: 'ML' },
  { label: 'No Coverage', value: 'NC' },
  { label: 'No Inspector', value: 'NI' },
  { label: 'Not Needed', value: 'NN' },
  { label: 'Other', value: 'OT' },
  { label: 'Site Refused', value: 'SR' },
];
export const INSPECTION_STATUSES: {
  value: InspectionStatus;
  label: string;
}[] = [
  { label: 'Backlog', value: 'BL' },
  { label: 'Planning', value: 'PL' },
  { label: 'Scheduled', value: 'SC' },
  { label: 'Booked', value: 'BOOKED' },
  { label: 'Complete', value: 'CO' },
  { label: 'Cancelled', value: 'CA' },
];
export const INSPECTION_TYPE: {
  value: InspectionType;
  label: string;
}[] = [
  { label: 'Standard', value: 'STD' },
  { label: 'Sirim', value: 'SIRIM' },
  { label: 'Pern', value: 'PERN' },
  { label: 'Supplier', value: 'SUPPLIER' },
];

export const INSPECTION_RESULTS: {
  value: InspectionResult;
  label: string;
}[] = [
  { label: 'Pending', value: InspectionResult.PENDING },
  { label: 'Failed', value: InspectionResult.FAILED },
  { label: 'Passed', value: InspectionResult.PASSED },
];
